import { Redirect } from "react-router-dom";
import { GlobalConstants } from "../constants/GlobalConstants";
import BCLayout from "../BCLayout";
import { AuthWrapper } from "../../App";
import "../../styles/lms/filter-tabs.scss";
import "../../styles/lms/lms-landing-pages.scss";
import "../../styles/lms/lms-global.scss";
import BCErrorBoundary from "../BCErrorBoundary";

const BrokerPages = ({ children, user }) => {
  return <>
    {(user.portal === GlobalConstants.Portals.BROKER) && <>{children}</>}
    {(user?.portal !== GlobalConstants.Portals.BROKER) && (
      <BCErrorBoundary>
        <Redirect to="/" />
      </BCErrorBoundary>
    )}
  </>;
};

const BrokerLayout = ({ children, user, bcLayoutProps }) => {
  return <AuthWrapper>
    <BCLayout {...bcLayoutProps}>
      <BrokerPages children={children} user={user} />
    </BCLayout>
  </AuthWrapper>;
};

export default BrokerLayout;